var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',{staticClass:"own-msg-wrap"},[_c('p',{staticClass:"own-msg"},[_vm._v(" "+_vm._s(_vm.content)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }